<template>
    <internal>
        <div
            v-if="branchid"
            class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg"
        >
            <Table
                @handleAction="handleAction"
                :searchable="true"
                :fields="fields"
                :items="admissions"
                :partial_count="partial_count"
                :searchlink="route('internal.admission.search', branchid)"
                :canView="
                    auth?.user?.role?.permissions?.find(
                        (permission) => permission.name === 'View Admission'
                    )
                "
            >
                <template #action_buttons>
                    <div class="flex items-center justify-end space-x-2">
                        <input
                            class="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                            type="checkbox"
                            id="showClosed"
                            v-model="filterForm.closed"
                            @change="applyClosedFilter"
                        />
                        <label
                            for="showClosed"
                            class="text-sm font-medium text-gray-900"
                            >Show closed</label
                        >
                    </div>
                    <div class="w-56">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        course: val ?? null,
                                        year: null,
                                        batch: null,
                                    });
                                    Inertia.visit(
                                        `${route(
                                            'internal.admission.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="courses"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.course_id"
                            :error="filterForm.errors.course_id"
                            returnValue="id"
                            placeholder="Select Course"
                        />
                    </div>
                    <div class="w-36">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        year: val ?? null,
                                        batch: null,
                                    });
                                    Inertia.visit(
                                        `${route(
                                            'internal.admission.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="years"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.course_year_id"
                            :error="filterForm.errors.course_year_id"
                            returnValue="id"
                            placeholder="Select year"
                        />
                    </div>
                    <div class="w-36">
                        <FormMultiselect
                            @change="
                                (val) => {
                                    let query = makeParameter({
                                        batch: val ?? null,
                                    });
                                    Inertia.visit(
                                        `${route(
                                            'internal.admission.list',
                                            branchid
                                        )}${query}`
                                    );
                                }
                            "
                            :required="true"
                            :options="batches_options"
                            track-key="title"
                            label-key="title"
                            :object="false"
                            v-model="filterForm.batch_id"
                            :error="filterForm.errors.batch_id"
                            returnValue="id"
                            placeholder="Select Batch"
                        />
                    </div>
                </template>
                <template #date="data">
                    {{ convertDate(data.item.created_at) }}
                </template>
                <template #student="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }}
                </template>
                <template #branch="data">
                    {{ data.item?.branch?.title }}
                </template>
                <template #duration="data">
                    {{ data.item.academicyear?.start_month }} -
                    {{ data.item.academicyear?.end_month }}
                </template>
                <template #course="data">
                    {{ data.item?.course?.title }}
                </template>
                <template #year="data">
                    {{
                        data.item?.course?.id ===
                        data.item.courseyear?.course_id
                            ? data.item?.courseyear?.title
                            : "-"
                    }}
                </template>
                <template #action="data">
                    <button-link
                        :href="
                            route('internal.admission.view', [
                                branchid,
                                data.item.id,
                            ])
                        "
                        >View</button-link
                    >
                </template>
                <template #partial_count>
                    {{ partial_count }}
                </template>
            </Table>
        </div>
        <Model
            :is-open="actionForm.is_open"
            v-if="actionForm.id == 'switch_branch'"
        >
            <template #body>
                <div class="flex-grow">
                    <FormMultiselect
                        :required="true"
                        label="Select Branch to move admission"
                        :options="branches"
                        track-key="title"
                        label-key="title"
                        :object="false"
                        returnValue="id"
                        placeholder="Select Branch"
                        v-model="actionForm.selectedBranchId"
                        class="w-5"
                    />
                    <InputError :message="actionForm.errors.selectedBranchId" />
                </div>
            </template>
            <template #buttons>
                <div class="flex justify-end">
                    <Button
                        @click="actionForm.is_open = false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4"
                        >Cancel
                    </Button>
                    <Button @click="handleSwitchBranch" class="mr-2"
                        >Submit</Button
                    >
                </div>
            </template>
        </Model>
        <Model :is-open="actionForm.is_open" v-else>
            <template #body>
                <div class="flex-grow">
                    <Label value="Select University Fees Status" />
                    <div class="flex space-x-8 mt-2">
                        <div class="">
                            <Label for="paid" value="Paid" />
                            <InputCheckbox
                                id="paid"
                                required
                                type="radio"
                                class="rounded-full"
                                name="gender"
                                :value="'paid'"
                                v-model="actionForm.id"
                                :checked="actionForm.id == 'paid'"
                            />
                        </div>
                        <div class="">
                            <Label for="unpaid" value="Unpaid" />
                            <InputCheckbox
                                id="unpaid"
                                required
                                type="radio"
                                value="unpaid"
                                :checked="actionForm.id == 'unpaid'"
                                class="rounded-full"
                                name="gender"
                                v-model="actionForm.id"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template #buttons>
                <div class="flex justify-end">
                    <Button
                        @click="actionForm.is_open = false"
                        class="bg-red-600 text-primary-light hover:!bg-red-300 hover:border-white mx-4"
                        >Cancel
                    </Button>
                    <Button @click="submitAction" class="mr-2">Submit</Button>
                </div>
            </template>
        </Model>
    </internal>
</template>

<script setup>
import Internal from "@/Pages/Internal/Internal";
import ButtonLink from "@/Components/ButtonLink";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import Model from "@/Components/Model.vue";
import { computed, onMounted, ref } from "vue";
import { useForm, usePage } from "@inertiajs/inertia-vue3";
import InputCheckbox from "@/Components/InputCheckbox.vue";
import Label from "@/Components/Label.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import { getParameters, makeParameter } from "../../../../Utils/Common";
import { Inertia } from "@inertiajs/inertia";
import InputError from "@/Components/InputError.vue";

const props = defineProps(["admissions", "partial_count"]);
const auth = usePage().props.value?.auth ?? {};

const fields = [
    { key: "roll_no", label: "Roll No" },
    { key: "date", label: "Date" },
    { key: "student", label: "Student" },
    { key: "branch", label: "Branch" },
    { key: "duration", label: "Academic Duration" },
    { key: "course", label: "Course" },
    { key: "year", label: "Year" },
    { key: "action", label: "Action" },
];
const branchid = ref();
const actionForm = useForm({
    selectedData: [],
    name: "",
    id: "",
    modal: "",
    action: "",
    controller: "",
    is_open: false,
    handleActions: false,
    confirm_message: "",
    url: "",
    selectedBranchId: null,
});
const parameters = getParameters();
const filterForm = useForm({
    batch_id: parameters?.batch,
    course_year_id: parameters?.year,
    course_id: parameters?.course,
    closed: false,
});
const branches = computed(() => usePage().props.value?.branches ?? []);
const courses = computed(() => usePage().props.value?.courses ?? []);
const years = computed(() => usePage().props.value?.years ?? []);
const batches_options = computed(
    () => usePage().props.value?.batches_options ?? []
);

const handleAction = ({ url, form }) => {
    actionForm.is_open = true;
    actionForm.name = form.name;
    actionForm.selectedData = form.selectedData;
    actionForm.id = form.id;
    actionForm.modal = form.modal;
    actionForm.action = form.action;
    actionForm.controller = form.controller;
    actionForm.handleActions = form.handleActions;
    actionForm.confirm_message = form.confirm_message;
    actionForm.url = url;
};
const submitAction = () => {
    actionForm.post(actionForm.url, {
        preserveState: false,
        onSuccess: () => {
            actionForm.reset();
        },
    });
};
onMounted(async () => {
    let _id = await localStorage.getItem("branchId");
    if (_id) {
        branchid.value = _id;
    }
    filterForm.closed = parameters?.closed == 1;
});

const handleSwitchBranch = () => {
    actionForm.post(route("internal.admissions.switch-branch"), {
        onSuccess: () => {
            actionForm.reset();
            showSuccessMessage(
                "Branch updated successfully for selected admissions."
            );
        },
    });
};

const applyClosedFilter = () => {
    let query = makeParameter({
        closed: filterForm.closed ? 1 : 0,
    });
    Inertia.visit(
        `${route("internal.admission.list", branchid.value)}${query}`
    );
};
</script>
